import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useIsPro } from 'hooks/useIsPro';
import cn from 'classnames';

import HelpButton from 'Components/HelpButton';

import DashboardHeader from 'Pages/TeamDashboard/Home/components/DashboardHeader';
import Sidebar from 'Pages/TeamDashboard/Home/components/Sidebar';

import { PLAN_CREDITS, SECTIONS } from 'utlis/constants';

import BillingSection from './BillingSection';
import ProfileSection from './ProfileSection';
import SettingsSidebar from './SettingsSidebar';

import styles from './styles.module.scss';

const Settings = () => {
  const [activeSection, setActiveSection] = useState(SECTIONS.PROFILE);

  const authUser = useSelector(state => state.userStore);
  const reviewData = useSelector(state => state.designReview.reviewCount);
  const isPro = useIsPro();

  const reviewsRemaining = reviewData?.reviews_remaining ?? 0;
  const totalCredits = isPro ? PLAN_CREDITS.PRO : PLAN_CREDITS.FREE;
  const isGoogleUser = authUser?.provider === 1;
  const creditPercentage = totalCredits > 0 ? (reviewsRemaining / totalCredits) * 100 : 0;

  return (
    <div className={styles['settings-container']}>
      <div className="min-h-screen bg-gray-50 flex w-full">
        <Sidebar />
        <div className="flex flex-1 bg-gray-50 p-2 pl-0 max-h-screen">
          <div className="flex flex-1 flex-col overflow-auto rounded-lg bg-white shadow-figma-sm relative">
            <DashboardHeader title="Settings" />

            <div className="flex flex-1 pl-40 items-center">
              <div
                className={cn(
                  'flex overflow-auto rounded-xl border border-[#E1E4E8] w-11/12',
                  'max-w-[960px] h-4/5 max-h-[720px]'
                )}
              >
                <SettingsSidebar
                  activeSection={activeSection}
                  onSectionChange={setActiveSection}
                />

                <div className={styles['settings-main']}>
                  {activeSection === SECTIONS.PROFILE && (
                    <ProfileSection authUser={authUser} isGoogleUser={isGoogleUser} />
                  )}
                  {activeSection === SECTIONS.BILLING && (
                    <BillingSection
                      reviewsRemaining={reviewsRemaining}
                      totalCredits={totalCredits}
                      creditPercentage={creditPercentage}
                    />
                  )}
                </div>
              </div>
            </div>

            <HelpButton />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
